import DoneJobs from './styled';

export default DoneJobs;
